import { useEffect, useState } from 'react'

/**
 * Hook to detect and track user's system dark mode preference
 * @returns Current dark mode preference (true for dark, false for light, null during initialization)
 */
export function useDarkMode(): boolean | null {
  const [prefersDarkMode, setPrefersDarkMode] = useState<boolean | null>(null)

  useEffect(() => {
    // Initial check for dark mode preference
    const darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)')
    setPrefersDarkMode(darkModeQuery.matches)

    // Add listener for changes to color scheme preference
    const handleDarkModeChange = (e: MediaQueryListEvent) => {
      setPrefersDarkMode(e.matches)
    }

    darkModeQuery.addEventListener('change', handleDarkModeChange)

    // Clean up listener on component unmount
    return () => {
      darkModeQuery.removeEventListener('change', handleDarkModeChange)
    }
  }, [])

  return prefersDarkMode
}
